import React from "react";
import styles from "./RsvpPeople.module.css";
import { Layout, List } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import bgcImage1 from "../../../../assets/bgcimage1.png";
import Rsvp from "../../../../assets/rsvp1.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { InputField } from "../../../../components";
import { BiSolidChevronRightCircle } from "react-icons/bi";
import Image1 from "../../../../assets/vendorimg6.png";
import Image2 from "../../../../assets/vendorimg7.png";
import Image3 from "../../../../assets/vendorimg6.png";
import Image4 from "../../../../assets/vendorimg7.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RsvpPeople = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const myStyle = {
    backgroundImage: `url(${bgcImage})`,
    backgroundRepeat: "no-repeat",
  };
  const myStyle1 = {
    backgroundImage: `url(${bgcImage1})`,
    backgroundRepeat: "no-repeat",
  };
  return (
    <div style={myStyle} className={styles.mainContainer}>
      <Header
        mainHeader={styles.headerColor}
        isProfile={true}
        title={"RSVP"}
        style={{ padding: 0, background: "var(--white-color)", height: 85 }}
        onBackClick={() => navigate(-1)}
      />

      <div style={myStyle1} className={styles.mainDiv}>
        <TextComponent text={"Wedding Party"} textClass={styles.title} />
        <div className={styles.innerContainer}>
          <List
            dataSource={rsvpData.families}
            className={styles.guestList}
            grid={{ lg: 3, xxl: 4, xl: 4, xs: 1, md: 2, sm: 1 }}
            renderItem={(item) => {
              return (
                <div className={styles.innerMainContainer}>
                  <div className={styles.innerRowContainer}>
                    <img src={item.image} className={styles.image1} />

                    <div className={styles.textContainer}>
                      <TextComponent textClass={styles.text} text={item.name} />
                      <TextComponent
                        textClass={styles.text2}
                        text={item.category}
                      />
                    </div>
                  </div>
                </div>
              );
            }}
          />
        </div>

        <BiSolidChevronRightCircle
          size={30}
          className={styles.icon}
          onClick={() => navigate("/rsvp/rsvpGuestSchedule", { state: state })}
        />
      </div>
    </div>
  );
};

export default RsvpPeople;
